<template>
  <gj-modal
      notFooterPadding
      size="1200_auto"
      :class="modalClass"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增广告商品</template>
    <template #content>
      <el-form
          ref="form"
          :model="form">
        <app-base-info
            ref="base"
            :market-id="marketId"
            :form="form.baseInfoForm"
            :campaign="campaign"
            :group="group"
            group-select
        ></app-base-info>
        <app-product-picker
            ref="picker"
            :market-id="marketId"
            :group-id="form.baseInfoForm.groupId"
            group-required
            :form="form.productPickerForm"
            :baseInfoForm="form.baseInfoForm"
            title="商品"
        ></app-product-picker>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {isMeaningfulMixin, isMeaninglessMixin, modalMixIn} from "@/minxins";
  import AppBaseInfo from "../common/base-info";
  import AppProductPicker from "../common/product-picker";
  import { SP } from "@/api/ad";
  import {AdGroupEnum} from "modules/ad/common/enum";

  export default {
    name: "app-add-sp-ad-product",
    components: {AppProductPicker, AppBaseInfo},
    mixins: [modalMixIn, isMeaninglessMixin, isMeaningfulMixin],
    props: {
      marketId: {
        required: true
      },
      campaign: {
        required: false,
        default: null
      },
      group: {
        required: false,
        default: null
      }
    },
    data() {
      return {
        form: {
          baseInfoForm: {
            campaignTargetType: AdGroupEnum.SP.targetingType.ALL,
            campaignId: null,
            groupId: null,
          },
          productPickerForm: {
            items: []
          }
        }
      }
    },
    computed: {
      modalClass() {
        if (this.isMeaningful(this.group)) {
          return 'gj-modal_1060X585';
        } else {
          return 'gj-modal_1060X607';
        }
      }
    },
    methods: {
      confirm() {
        this.confirmLoading = true;
        let formValid = ['base', 'picker']
          .map(e => this.$refs[e]?.formValidate());
        Promise.all([...formValid])
          .then(() => this.productAdd())
          .catch((error) => console.log('zs', error))
          .complete(() => this.confirmLoading = false)
      },
      productAdd() {
          const params = {
            marketId: this.marketId,
            params: this.form.productPickerForm.items.map(e => ({
              campaignId: this.form.baseInfoForm.campaignId,
              groupId: this.form.baseInfoForm.groupId,
              sku: e.msku,
              asin: e.asin
            }))
          };
          this.confirmLoading = true;
          SP.productAdd(params)
            .then(() => {
              this.$gjDestroy();
              this.$emit('created');
            })
            .complete(() => this.confirmLoading = false);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";
</style>



